/*
Выводит строку с чекбоксом в фильтре
*/

export default {
  name: 'MapFilterCheckComponent',
  props: ['img', 'name', 'active', 'disabled'],
  template: `
    <div class="partners-map-filter-check" :class="{'partners-map-filter-check--active': active, 'partners-map-filter-check--disabled': disabled}">
      <div v-if="img" class="partners-map-filter-check__icon">
        <img :src="img">
      </div>
      <div class="partners-map-filter-check__text">
        {{name}}
      </div>
      <div class="partners-map-filter-check__check">
        <img src="/local/templates/new_site_v2/images/parthners_map/check.svg">
      </div>
    </div>
  `,
}
